<!--
  Name + type of an existing zone, editable. Shared by the zone editor
  (DetectionZone.vue) and the demo test page (StoralyticDemoZoneEditor.vue), so what is
  tried in the demo is the component that ships.

  The parent passes the type list (the editor reads it from the API, the demo cannot)
  and the names of the OTHER zones on the same camera; this component only checks and
  reports — the parent decides what Save does.
-->
<template>
  <div class="zone-identity">
    <div class="fields">
      <input
        class="input"
        type="text"
        :value="name"
        :placeholder="$t('zoneSettings.identity.namePlaceholder')"
        :aria-label="$t('zoneSettings.identity.namePlaceholder')"
        @input="$emit('update:name', $event.target.value)"
      />
      <select
        class="form-select"
        :value="type"
        :aria-label="$t('zoneSettings.identity.typePlaceholder')"
        @change="$emit('update:type', $event.target.value)"
      >
        <option disabled value="">{{ $t('zoneSettings.identity.typePlaceholder') }}</option>
        <option v-for="t in typeOptions" :key="t" :value="t">{{ zoneTypeLabel(t) }}</option>
      </select>
    </div>
    <p v-if="check.error" class="msg error" role="alert">{{ check.error }}</p>
    <p v-else-if="change" class="msg info">{{ change }}</p>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { describeChange, validateZoneIdentity } from '@/zones/zoneIdentity'
import { zoneTypeLabel } from '@/i18n/zoneTypes'

const props = defineProps({
  name: { type: String, default: '' },
  type: { type: String, default: '' },
  originalName: { type: String, default: null },
  originalType: { type: String, default: null },
  typeOptions: { type: Array, default: () => [] },
  takenNames: { type: Array, default: () => [] },
})
const emit = defineEmits(['update:name', 'update:type', 'validity'])

const check = computed(() => validateZoneIdentity(props))
const change = computed(() => describeChange(props))

watch(() => check.value.ok, (ok) => emit('validity', ok), { immediate: true })
</script>

<style scoped>
.zone-identity { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.fields { display: flex; gap: 8px; flex-wrap: wrap; }
.fields .input { flex: 1 1 160px; min-width: 0; padding: 6px 8px; border: 1px solid #c9d2d8; border-radius: 6px; }
.fields .form-select { flex: 1 1 180px; min-width: 0; }
.msg { margin: 0; font-size: 0.85rem; }
.msg.error { color: #b42318; }
.msg.info { color: #3c5a6b; }
</style>
